import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";
//import { Form, Button, Row } from "react-bootstrap";
import { Button, Grid, Typography } from "@material-ui/core";
//Inputs
import { FormItem } from "react-material-formik-wizard";
import MKDatePicker from "components/MKDatePicker";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

const DisplaySchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Required"),
  img_url: Yup.string().trim().url("Invalid url").required("Required"),
  author: Yup.string(),
});

const PolicyCoverPeriodStep = ({ back, next, values = null }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentValues, setCurrentValues] = useState([]);
  console.log(
    "🚀 ~ file: index.js:27 ~ PolicyCoverPeriodStep ~ currentValues:",
    currentValues
  );

  useEffect(() => {
    mapValues();
  }, [startDate, endDate]);
  const mapValues = () => {
    setCurrentValues({
      values: values,
      period: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  };

  return (
    <React.Fragment>
      <Formik
        enableReinitialize={true}
        initialValues={currentValues}
        // validationSchema={DisplaySchema}
        onSubmit={(currentValues) => {
          console.log(
            "🚀 ~ file: index.js:53 ~ PolicyCoverPeriodStep ~ currentValues:",
            currentValues
          );
          next(currentValues);
        }}
      >
        {({
          isSubmitting,
          values,
          errors,
          handleSubmit,
          handleChange,
          touched,
          handleBlur,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={3}
              direction="row"
              alignItems="center"
              justifyContent="center"
              width="100%"
              style={{ paddingTop: 50, paddingBottom: 50 }}
            >
              <Grid item xs={12} md={8} lg={8}>
                <MKTypography
                  variant="h4"
                  type="title"
                  color="inherit"
                  style={{ flex: 1 }}
                >
                  Policy Cover Period
                </MKTypography>
                <MKTypography
                  variant="body"
                  fontSize="medium"
                  opacity={0.8}
                  fontWeight="regular"
                >
                  Ensure to provide your desired cover period below: -
                </MKTypography>
              </Grid>
              <Grid item xs={12}>
                <MKDatePicker
                  options={{ minDate: Date.now(), dateFormat: "d-M-Y" }}
                  label="Select Start Date"
                  value={startDate}
                  name="startDate"
                  onChange={(item) =>
                    setStartDate(
                      moment(item[0]).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
                    )
                  }
                />
              </Grid>
              {startDate && (
                <MKTypography>
                  Start Date:{" "}
                  <strong>{moment(startDate).format("DD-MMM-Y")}</strong>
                </MKTypography>
              )}
              <Grid item xs={12}>
                <MKDatePicker
                  options={{ minDate: Date.now(), dateFormat: "d-M-Y" }}
                  label="Select End Date"
                  value={endDate}
                  onChange={(item) =>
                    setEndDate(
                      moment(item[0]).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
                    )
                  }
                />
              </Grid>
              {endDate && (
                <MKTypography>
                  End Date:{" "}
                  <strong>{moment(endDate).format("DD-MMM-Y")}</strong>
                </MKTypography>
              )}
            </Grid>
            {/* <Grid
              container
              spacing={0}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item>
                <Button
                  disabled={isSubmitting}
                  onClick={(e) => back(e, values)}
                >
                  Back
                </Button>
              </Grid>
              <Grid item>
                <Button
                  disabled={
                    isSubmitting ||
                    Object.entries(errors).length > 0 ||
                    !startDate ||
                    !endDate
                  }
                  type="submit"
                >
                  Next
                </Button>
              </Grid>
            </Grid> */}

            <Grid
              container
              spacing={0}
              direction="row"
              justifyContent="space-between"
            >
              <Grid item md={1} lg={1}>
                <MKButton
                  disabled={isSubmitting}
                  onClick={(e) => back(e, values)}
                >
                  Back
                </MKButton>
              </Grid>
              <Grid item md={10} lg={10} />
              <Grid item md={1} lg={1}>
                <MKButton
                  disabled={
                    isSubmitting ||
                    Object.entries(errors).length > 0 ||
                    !startDate ||
                    !endDate
                  }
                  type="submit"
                >
                  Next
                </MKButton>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );
};
export default PolicyCoverPeriodStep;
